import { onDocumentEvent } from '@app/utils/domHelpers'
import updateTitleOnSelection from '../../common/update-title-on-selection'

const handleTextSelectChange = updateTitleOnSelection(
  '[data-behaviour~="export-element"]',
  '#export_permanent_text_title'
)

export default () =>
  onDocumentEvent(
    document,
    'change',
    '[data-behaviour="export-text-select"]',
    handleTextSelectChange
  )
